<template>
  <div id="app" v-cloak>
    <!-- <transition> -->
    <router-view v-if='!$route.meta.keepAlive'></router-view>
    <!-- </transition> -->
  </div>
</template>
<script>
export default {
  created () { }
}
</script>
<style lang="less">
// .v-enter {
//   opacity: 0;
//   transform: translateX(100%);
// }
// .v-leave-to {
//   opacity: 0;
//   transform: translateX(-100%);
//   // 解决页面从上往下位移问题
//   position: absolute;
// }
// .v-enter-active,
// .v-leave-active {
//   transition: all 0.5s ease;
// }
</style>
